<template>
    <Popup
        :modelValue=!!selectedRow
        @update:model-value=closeChild
        title="VCFS Payment Confirmation"
        hasClose
    >
        <template #contents>
            <div class="top-content">
                <div class="grid-item">
                    Confirming that the payment to VCFS of the amount {{ MonetaryValueWithCommas(selectedRow?.amount)  }} has been executed on the following date
                </div>
                <form class="top-content" @submit.prevent=ConfirmPayment>
                    <div class="date-picker vcfs-date-selector">
                        <DatePicker
                        v-model=selectedDate
                        placeholder="Select payment confirmation date..."
                        :text-input-options=textInputOptions
                        :max-date="today"
                        :enable-time-picker=false
                        :format=FormatDatePicker
                        :teleport=true
                        text-input
                        required
                        />
                    </div>
                    <div class="flex-col-centered">
                        <button class="submit-btn" type="submit">
                            CONFIRM PAYMENT
                        </button>
                    </div>
                </form>
            </div>
        </template>
    </Popup>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import Popup from "./Popup.vue";
import DatePicker from "./common/DatePicker.vue";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import { vcfsPaymentsService } from "@/services/network";
import { IVcfsPaymentRequest } from "@/Interfaces/Payments/IVcfsPaymentRequest";
import { IVcfsPaymentItem } from "@/Interfaces/Payments/IVcfsPaymentItem";
import { MonetaryValueWithCommas } from "@/services/helpers/Helper";

const props = defineProps<{
    modelValue?: IVcfsPaymentItem|undefined;
}>();
const selectedRow = computed({
    get() {
        return props.modelValue
    },
    set(val) {
        emits('update:modelValue', val);
    }
});
const emits = defineEmits<{
    (e: 'update:modelValue', val: IVcfsPaymentItem | undefined);
    (e: 'confirm'): void;
}>();

const textInputOptions = { format: "yyyy-MM-dd" };
const today = new Date();
const selectedDate = ref<Date>();
const working = ref(false);

function closeChild() {
    selectedRow.value = undefined;
}
function FormatDatePicker(date: Date){
    return new DateIgnoreTime(date).toString();
}
async function ConfirmPayment() {
    if(working.value == true) return;
    const closeSpinner = useSpinnerPopup().show();
    try{
        working.value = true
        const paymentReference = selectedRow.value?.paymentReference
        if(paymentReference ==undefined)
        {
            useNotifierWithErrFormatter().notify({msg:"Payment reference can not be undefined"})
        }
        const postRequest: IVcfsPaymentRequest = 
        {
            user: authService.getEmailAddress(), 
            date: new DateIgnoreTime(selectedDate.value)
        }
        await vcfsPaymentsService.put(
            { paymentReference: paymentReference as string}, 
            postRequest
        );
    }catch(error){
        useNotifierWithErrFormatter().error({errorType:"VCFS payment confirmation", error})
    }finally{
        closeSpinner();
        working.value = false
        closeChild()
        emits("confirm");
    }
}
</script>
<style scoped>
@import "@/assets/styles/selection-form-inputs.scss";
.grid-item {
    padding: 10px;
}
.submit-btn {
    margin-top: 1rem;
    cursor: pointer;
    border-width: 0px;
    border-radius: var(--buttons-border-radius);
    background-color: var(--primary-color-lighter);
    padding: 10px;
    color: blue;
    font-size: larger;
    font-weight: bold;
    &:hover {
        color: white;
        background-color: var(--primary-color);
    }
}
.vcfs-date-selector {
    width: 80%; 
    margin: auto;
    max-width: 600px;
}
</style>
